import { render } from "./AppAlerts.vue?vue&type=template&id=37f5d5a4&scoped=true"
import script from "./AppAlerts.vue?vue&type=script&lang=js"
export * from "./AppAlerts.vue?vue&type=script&lang=js"

import "./AppAlerts.vue?vue&type=style&index=0&id=37f5d5a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f5d5a4"]])

export default __exports__